import React, { useEffect } from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ThemeProvider } from '@material-ui/core/styles';
import firebase from 'firebase';

import AuthDataProvider from './context/auth/auth.provider';
import SidebarProvider from './context/sidebar/sidebar.provider';
import { initFirebase } from './helpers/firebase';
import DefaultLayout from './layouts/default.layout';
import Maintenance from './screens/Maintenance/Maintenance';
import { theme } from './theme';

// Create a client
const queryClient = new QueryClient();
function App() {
  const [maintenance, setMaintenance] = useState<boolean | null>(null);

  const initializeFirebase = useCallback(async () => {
    try {
      await initFirebase();
      // TODO: cambiar a un listener
      const remoteConfig = firebase.remoteConfig();
      remoteConfig.settings.minimumFetchIntervalMillis = 1;
      await remoteConfig.fetchAndActivate();
      setMaintenance(
        remoteConfig.getBoolean(
          `IN_MAINTENANCE_${process.env.REACT_APP_WEBSITE}_${process.env.REACT_APP_FIREBASE_ENVIRONMENT}`
        )
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    if (maintenance !== null) {
      document.getElementById('loader-container')?.remove();
    }

    initializeFirebase();
  }, [initializeFirebase, maintenance]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <AuthDataProvider>
          {maintenance === null || !maintenance ? ( // true or false
            <SidebarProvider>
              <DefaultLayout />
            </SidebarProvider>
          ) : maintenance !== null ? (
            <Maintenance />
          ) : null}
        </AuthDataProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

App.displayName = 'App';

export default App;
